import React,{Fragment} from 'react';
import './App.css';
import Inicio from './pages/Inicio'
import Proveedores from './pages/Proveedores';
import Empleados from './pages/Empleados';
import Tienda from './pages/Tienda';
import Productodetalle from './pages/Productodetalle';
import{BrowserRouter,Routes,Route} from 'react-router-dom'
import Carrito from './pages/Carrito';
import Categorias from './pages/tablas/Categorias';


function App() {
   return (
    <Fragment>
     <BrowserRouter>
     <Routes>
          <Route path='/'  element={<Inicio />} />
          <Route path='/proveedores'  element={<Proveedores />} />
          <Route path='/empleados'  element={<Empleados />} />
          <Route path='/tienda'  element={<Tienda />} />
          <Route path='/tienda/detalle/:idproducto'  element={<Productodetalle />} />
          <Route path='/carrito'  element={<Carrito />} />
          <Route path='/categoria'  element={<Categorias />} />
      </Routes>
     </BrowserRouter>
    </Fragment>
  );
}

export default App;
